import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const OAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");

    if (code) {
      // Store the authorization code for later exchange by your backend
      window.sessionStorage.setItem("oauth_code", code);

      // TODO: exchange `code` for an access token on the server, then
      // store the token (e.g. in sessionStorage) and redirect to the CAE dashboard.
      // Example (pseudo):
      // fetch('/api/auth/exchange', { method: 'POST', body: JSON.stringify({ code }) })
      //   .then(res => res.json())
      //   .then(data => { sessionStorage.setItem('user_token', data.token); navigate('/CAE/SettingDashboard', { replace: true }); });

      // For now, remove the query and redirect to the app root (login flow can continue)
      window.history.replaceState({}, document.title, location.pathname);
      navigate("/", { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [location, navigate]);

  return <div>Processing authentication...</div>;
};

export default OAuthCallback;
